/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Domino from './Domino'
import {
  HANDICAP_TYPE,
  ACCESSIBILITY_LEVEL,
  ACCESSIBILITY_LEVEL_LETTER,
} from '../../domains/cards/enums/handicaps'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    width: theme.spacing(5),
    height: theme.spacing(5),
  },
}))

const generateTooltip = (handicap, value) => {
  const textTooltip = HANDICAP_TYPE[handicap] || ''
  const textAccessibilityLevel = ACCESSIBILITY_LEVEL[value] || ''
  const accessibilityLevelLetter = ACCESSIBILITY_LEVEL_LETTER[value] || ''

  return (
    <>
      {textTooltip}
      <br />
      <b>
        {accessibilityLevelLetter
          ? `${accessibilityLevelLetter} - ${textAccessibilityLevel}`
          : textAccessibilityLevel}
      </b>
    </>
  )
}

const HandicapsIcon = (props) => {
  const { value, slug } = props
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Domino
        tooltip={generateTooltip(slug, value)}
        handicap={slug}
        value={value}
      />
    </div>
  )
}

export default HandicapsIcon
